import SMFormSubmitButton from './SMFormSubmitButton';

export default SMFormSubmitButton;
